
const defaultRender = (value) => (value === '' ? 0 : value ? value : '--');


const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title: 'From',
        dataIndex: 'from',
    },
    {
        title: '	To',
        dataIndex: 'to',
    },
    {
        title: 'Transaction Type',
        dataIndex: 'type',
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
    },
    {
        title: 'Transaction Fee',
        dataIndex: 'commission',
        render: defaultRender,
    },
    {
        title: 'Transaction Date',
        dataIndex: 'createdDate',
        render: defaultRender,
    },
    {
        title: 'Status',
        dataIndex: 'status',
    }

];

export default columns;